import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PostService } from 'src/app/_services/post/post.service';
import { Post } from 'src/app/Model/Post';
import { Meta } from '@angular/platform-browser';
//declare const share: any;
declare const modalImage: any;

@Component({
  selector: 'app-get-post-by-id',
  templateUrl: './get-post-by-id.component.html',
  styleUrls: ['./get-post-by-id.component.css']
})
export class GetPostByIdComponent implements OnInit {
  hero$: any;
  post: any = new Post;
  file: boolean   = false ; 
  image : boolean = false ; 
  constructor(private route: ActivatedRoute,
    private router: Router, private servicePost: PostService, private meta: Meta) {
      setTimeout(function () {
        modalImage();
    }, 1000);

      this.meta.addTag({ property: 'og:title', content: 'mlkvgbù' });
      this.meta.addTag({ property: 'og:url', content:'http://notregrandbleu.org/getPostById;id=5f50b8b15f76a70004c1a2f1' });
      this.meta.addTag({ property: 'og:image', content:'http://notregrandbleu.org/assets/img/posts/2020939343.jpg' , itemprop: 'image' });
      this.meta.addTag({ property: 'og:image:url', content: 'http://notregrandbleu.org/assets/img/posts/2020939343.jpg' , itemprop: 'image' });
      this.meta.addTag({ property: 'og:image:type', content: 'image/png' });
      
    const heroId = this.route.snapshot.paramMap.get('id');
    this.servicePost.getById(heroId).subscribe(res => {
      this.post = res[0];
      if(this.post.image.indexOf('pdf')!== -1)
      {
        this.file = true ; 
      }
      if(this.post.image.indexOf('png')!== -1 || this.post.image.indexOf('jpg')!== -1)
      {
        this.image = true ; 
      }

    });
  }
  ngOnInit(): void { modalImage(); }

}
